<template>
    <div
        class="row"
        :class="$style.row"
    >
        <div class="col-12 text-center">
            <img
                v-if="$app.login.logo"
                :src="$app.login.logo"
                :class="$style.logo"
            >

            <g-project-logo
                v-else
                :dark="true"
                class="mb-5"
            />

            <div :class="$style.form">
                <div
                    v-if="$app.pack"
                    :class="$style.formTab"
                >
                    <a-tabs
                        v-model="tab"
                        default-active-key="1"
                        class="hidden-tabs "
                    >
                        <a-tab-pane
                            :key="1"
                            tab="Tab 1"
                        >
                            <project @next="tab = 2" />
                        </a-tab-pane>
                        <a-tab-pane
                            :key="2"
                            tab="Tab 2"
                            force-render
                        >
                            <login @back="tab = 1" />
                        </a-tab-pane>
                    </a-tabs>
                </div>
                <div
                    v-else
                    :class="$style.formTab"
                >
                    <login />
                </div>
            </div>
            <terms />
        </div>
        <div
            :class="$style.bg"
            :style="bgStyle"
        />
    </div>
</template>

<script>
import project from './steps/1'
import login from './steps/2'

export default {
    name: 'Login',
    components: {
        project,
        login
    },
    data() {
        return {
            tab: 1
        }
    },
    computed: {
        bgStyle() {
            const styles = {}

            if (this.$app.login.bgColor) styles['background-color'] = this.$app.login.bgColor
            if (this.$app.login.bgImage) styles['background-image'] = `url('${this.$app.login.bgImage}')`
            if (this.$app.login.bgSize) styles['background-size'] = this.$app.login.bgSize

            return styles
        }
    },
    created() {
        if (this.$gestios.project.name) {
            this.tab = 2
        }
    }
}
</script>

<style lang="scss" module>
.form {
    background: white;
    height: 100%;
    justify-content: center;
    display: flex;
    flex-direction: column;
    max-width: 500px;
    padding: 60px;
    border-radius: 20px;
    margin: 0 auto 40px auto;
}

.formTab {
    min-width: 100%;
    align-self: center;
}

.info {
    position: relative;
    z-index: 1;
    height: 100%;
    justify-content: center;
    flex-direction: column;
}

.bg {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    position: fixed;
    width: calc(100% + 80px);
    height: calc(100% + 80px);
    left: 0;
    top: 0;
    z-index: -1;
    margin: -40px;
    filter: blur(8px);
    -webkit-filter: blur(8px);
}

.row {
    background-size: auto 100%;
    height: 100vh;
    align-items: center;
    display: flex;
}

.logo {
    margin-bottom: 20px;
    max-width: 300px;
}

@media (max-width: $sm-min-width) {
    .form {
        padding: 30px;
    }
}

[data-kit-theme='dark'] {
    .form {
        background: $dark;
    }
}
</style>
